import type { SSR } from "@repo/ui/types/booking";

type PurchaseStateKeys = Pick<SSR, "inBundle" | "isConfirmed" | "isConfirmingUnheld">;

function isPurchasedSSR(ssr: PurchaseStateKeys): boolean {
  return Boolean(ssr.inBundle || ssr.isConfirmed || ssr.isConfirmingUnheld);
}

export function findSSRWithPurchasePriority(
  ssrs: readonly SSR[],
  purchasedCodes: readonly string[],
  fallbackCode: string,
): SSR | undefined {
  return (
    ssrs.find((s) => purchasedCodes.includes(s.ssrCode) && isPurchasedSSR(s)) ??
    ssrs.find((s) => s.ssrCode === fallbackCode)
  );
}
